__webpack_require__.p = "/ae/en/local-apps/ikea-self-service-tools/web/v0.1/";